import { Entitlements } from '@trello/entitlements';

import { isAdminOfBoard } from './isAdminOfBoard';

export const canDeleteBoard = (
  member: {
    id: string;
    idEnterprisesAdmin: Array<string>;
    idPremOrgsAdmin: Array<string>;
    memberType: 'ghost' | 'normal';
  },
  board: { id: string } & {
    memberships: {
      id: string;
      deactivated: boolean;
      idMember: string;
      memberType: 'admin' | 'normal' | 'observer';
      unconfirmed: boolean;
    }[];
    organization?:
      | ({ id: string; offering: string } & {
          memberships: {
            deactivated: boolean;
            idMember: string;
            memberType: 'admin' | 'normal';
            unconfirmed: boolean;
          }[];
        })
      | null;
    prefs?: {
      permissionLevel: 'enterprise' | 'org' | 'private' | 'public';
    } | null;
  },
  workspace?: {
    prefs?: {
      boardDeleteRestrict?: {
        __typename: 'Organization_Prefs_BoardDeleteRestrict';
        enterprise: 'admin' | 'none' | 'org';
        org: 'admin' | 'none' | 'org';
        private: 'admin' | 'none' | 'org';
        public: 'admin' | 'none' | 'org';
      } | null;
    } | null;
    memberships?: { idMember: string; memberType: 'admin' | 'normal' }[] | null;
  },
): boolean => {
  if (!board) {
    return false;
  }

  const isAdmin = isAdminOfBoard(member, board);
  if (!isAdmin) {
    return false;
  }

  if (!workspace) {
    return true;
  }

  const workspaceDeleteRestrictions = workspace?.prefs?.boardDeleteRestrict;
  if (!workspaceDeleteRestrictions) {
    return true;
  }

  const boardPermission = board?.prefs?.permissionLevel;
  if (!boardPermission) {
    return true;
  }

  const workspaceDeleteRestriction =
    workspaceDeleteRestrictions[boardPermission];

  switch (workspaceDeleteRestriction) {
    case 'org':
      return true;

    case 'admin': {
      const isWorkspaceAdmin = (workspace.memberships || []).some(
        ({ idMember, memberType }) => {
          return idMember === member.id && memberType === 'admin';
        },
      );

      if (
        isWorkspaceAdmin &&
        !Entitlements.isFree(board.organization?.offering)
      ) {
        return true;
      }

      return false;
    }

    default:
      return false;
  }
};
